import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import './FeedbackSection.css';

const EMAILJS_SERVICE_ID  = 'service_v06l9c9';
const EMAILJS_TEMPLATE_ID = 'template_x1kqax4';
const EMAILJS_PUBLIC_KEY  = 'uyhW5UG84CxjdPt-8';

const reviews = [
  { stars: 5, text: '"CropGuard AI saved my entire tomato harvest this season. The early blight detection was spot on and the treatment suggestion worked perfectly."', name: 'Ahmad Raza', role: 'Tomato Farmer, Punjab', emoji: '👨‍🌾' },
  { stars: 5, text: '"As an agricultural consultant, I recommend CropGuard to all my clients. The accuracy and speed of detection is remarkable for a free web tool."', name: 'Dr. Sana Malik', role: 'Agricultural Researcher', emoji: '👩‍🔬' },
  { stars: 4, text: '"Using this on my maize fields has been a game changer. Simple enough for my father (who barely uses smartphones) and accurate enough for us."', name: 'Usman Farooq', role: 'Maize Farmer, Sindh', emoji: '🧑‍🌾' },
];

const STARS = [
  { value: '5', label: '⭐⭐⭐⭐⭐ Excellent' },
  { value: '4', label: '⭐⭐⭐⭐ Very Good' },
  { value: '3', label: '⭐⭐⭐ Good' },
  { value: '2', label: '⭐⭐ Fair' },
];

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function validate(form) {
  const errors = {};
  if (!form.name.trim()) {
    errors.name = 'Name is required.';
  } else if (form.name.trim().length < 3) {
    errors.name = 'Name must be at least 3 characters.';
  }
  if (!form.email.trim()) {
    errors.email = 'Email is required.';
  } else if (!emailRegex.test(form.email.trim())) {
    errors.email = 'Please enter a valid email address.';
  }
  if (!form.rating) {
    errors.rating = 'Please select a rating.';
  }
  if (!form.comment.trim()) {
    errors.comment = 'Comment is required.';
  } else if (form.comment.trim().length < 10) {
    errors.comment = 'Comment must be at least 10 characters.';
  }
  return errors;
}

const errorStyle = {
  color: '#ff8a8a',
  fontSize: '.8rem',
  marginTop: 4,
  display: 'block',
};

export default function FeedbackSection() {
  const [form,    setForm]    = useState({ name: '', email: '', rating: '', comment: '' });
  const [errors,  setErrors]  = useState({});
  const [touched, setTouched] = useState({});
  const [status,  setStatus]  = useState('idle');

  const handleChange = (field, value) => {
    const updated = { ...form, [field]: value };
    setForm(updated);
    if (touched[field]) {
      const newErrors = validate(updated);
      setErrors(prev => ({ ...prev, [field]: newErrors[field] }));
    }
  };

  const handleBlur = (field) => {
    setTouched(prev => ({ ...prev, [field]: true }));
    const newErrors = validate(form);
    setErrors(prev => ({ ...prev, [field]: newErrors[field] }));
  };

  const submit = async () => {
    setTouched({ name: true, email: true, rating: true, comment: true });
    const newErrors = validate(form);
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return;

    setStatus('sending');
    try {
      await emailjs.send(
        EMAILJS_SERVICE_ID,
        EMAILJS_TEMPLATE_ID,
        {
          from_name:  form.name,
          from_email: form.email,
          rating:     form.rating + ' stars',
          comment:    form.comment,
          to_email:   'shah2304shah@gmail.com',
        },
        EMAILJS_PUBLIC_KEY
      );
      setStatus('sent');
      setForm({ name: '', email: '', rating: '', comment: '' });
      setErrors({});
      setTouched({});
      setTimeout(() => setStatus('idle'), 5000);
    } catch (err) {
      console.error('EmailJS error:', err);
      setStatus('error');
      setTimeout(() => setStatus('idle'), 4000);
    }
  };

  const inputStyle = (field) => ({
    borderColor: errors[field] ? 'rgba(255,80,80,.6)' : undefined,
  });

  return (
    <section id="feedback">
      <div className="container">
        <div className="text-center mb-5 reveal">
          <span className="section-label">User Reviews</span>
          <h2 className="section-title">
            What Farmers <span className="accent">Say</span>
          </h2>
        </div>

        {/* Review Cards */}
        <div className="row g-4 mb-5">
          {reviews.map((r, i) => (
            <div className="col-md-6 col-lg-4 reveal" key={i}>
              <div className="review-card">
                <div className="star-row">{'★'.repeat(r.stars)}{'☆'.repeat(5 - r.stars)}</div>
                <p className="review-text">{r.text}</p>
                <div className="d-flex align-items-center gap-3">
                  <div className="reviewer-avatar">{r.emoji}</div>
                  <div>
                    <div className="reviewer-name">{r.name}</div>
                    <div className="reviewer-role">{r.role}</div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Feedback Form */}
        <div className="row justify-content-center reveal">
          <div className="col-lg-8">
            {status === 'sent' ? (
              <div className="feedback-success">
                <div style={{ fontSize: '3rem', marginBottom: 12 }}>✅</div>
                <h4 style={{ color: 'var(--cream)', fontFamily: 'Playfair Display,serif', marginBottom: 8 }}>Thank You!</h4>
                <p style={{ color: 'var(--text-muted)' }}>
                  Your feedback has been sent to <strong style={{ color: 'var(--green-accent)' }}>shah2304shah@gmail.com</strong>.<br />
                  We really appreciate your time!
                </p>
              </div>
            ) : (
              <div className="detect-box">
                <h4 style={{ color: 'var(--cream)', marginBottom: 6, fontFamily: 'Playfair Display,serif' }}>Share Your Experience</h4>
                <p style={{ color: 'var(--text-muted)', fontSize: '.9rem', marginBottom: 24 }}>
                  Your feedback helps us improve CropGuard AI for farmers everywhere.
                </p>

                {status === 'error' && (
                  <div style={{ background: 'rgba(255,80,80,.1)', border: '1px solid rgba(255,80,80,.3)', borderRadius: 10, padding: '12px 16px', marginBottom: 16, color: '#ff8a8a', fontSize: '.88rem' }}>
                    <i className="bi bi-exclamation-circle me-2"></i>
                    Failed to send. Please check EmailJS setup or try again.
                  </div>
                )}

                <div className="row g-3">
                  <div className="col-md-6">
                    <input
                      className="form-control-green"
                      placeholder="Your Name"
                      value={form.name}
                      style={inputStyle('name')}
                      onChange={e => handleChange('name', e.target.value)}
                      onBlur={() => handleBlur('name')}
                    />
                    {errors.name && <span style={errorStyle}><i className="bi bi-exclamation-circle me-1"></i>{errors.name}</span>}
                  </div>
                  <div className="col-md-6">
                    <input
                      className="form-control-green"
                      placeholder="Email Address"
                      type="email"
                      value={form.email}
                      style={inputStyle('email')}
                      onChange={e => handleChange('email', e.target.value)}
                      onBlur={() => handleBlur('email')}
                    />
                    {errors.email && <span style={errorStyle}><i className="bi bi-exclamation-circle me-1"></i>{errors.email}</span>}
                  </div>
                  <div className="col-12">
                    <select
                      className="form-control-green"
                      value={form.rating}
                      style={inputStyle('rating')}
                      onChange={e => handleChange('rating', e.target.value)}
                      onBlur={() => handleBlur('rating')}
                    >
                      <option value="" disabled>Select Rating</option>
                      {STARS.map(s => <option key={s.value} value={s.value}>{s.label}</option>)}
                    </select>
                    {errors.rating && <span style={errorStyle}><i className="bi bi-exclamation-circle me-1"></i>{errors.rating}</span>}
                  </div>
                  <div className="col-12">
                    <textarea
                      className="form-control-green"
                      placeholder="Tell us about your experience..."
                      value={form.comment}
                      style={inputStyle('comment')}
                      onChange={e => handleChange('comment', e.target.value)}
                      onBlur={() => handleBlur('comment')}
                    />
                    {errors.comment && <span style={errorStyle}><i className="bi bi-exclamation-circle me-1"></i>{errors.comment}</span>}
                  </div>
                  <div className="col-12">
                    <button
                      className="btn-primary-green w-100 justify-content-center"
                      onClick={submit}
                      disabled={status === 'sending'}
                      style={{ borderRadius: 12, padding: '14px', border: 'none', opacity: status === 'sending' ? .7 : 1 }}
                    >
                      {status === 'sending'
                        ? <><i className="bi bi-hourglass-split me-2"></i>Sending...</>
                        : <><i className="bi bi-send me-2"></i>Submit Feedback</>
                      }
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
